import React from 'react';
import '../styles/org-buttons.css';
import './Pagination.css';
import { buttonText } from "../utils/buttonText";
import { pageText } from "../utils/pageText";

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  hasNextPage,
  hasPrevPage
}) => {
  if (totalPages <= 1) return null;

  const handlePageChange = (nextPage) => {
    onPageChange(nextPage);
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 7;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);

      let start = Math.max(2, currentPage - 2);
      let end = Math.min(totalPages - 1, currentPage + 2);

      if (start > 2) {
        pages.push('...');
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < totalPages - 1) {
        pages.push('...');
      }

      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <div className="dataset-pagination">
      <div className="dataset-pagination-controls">
        <button
          type="button"
          className="org-btn org-btn-secondary dataset-pagination-btn nav"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={!hasPrevPage}
        >
          {buttonText("Prev")}
        </button>

        {getPageNumbers().map((page, index) => (
          page === '...' ? (
            <span key={`ellipsis-${index}`} className="dataset-pagination-ellipsis">
              ...
            </span>
          ) : (
            <button
              key={page}
              type="button"
              className={`org-btn dataset-pagination-btn${
                currentPage === page ? ' org-btn-primary active' : ' org-btn-secondary'
              }`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          )
        ))}

        <button
          type="button"
          className="org-btn org-btn-secondary dataset-pagination-btn nav"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={!hasNextPage}
        >
          {buttonText("Next")}
        </button>
      </div>

      <span className="dataset-pagination-summary">
        {pageText(`Page ${currentPage} of ${totalPages}`)}
      </span>
    </div>
  );
};

export default Pagination;
